import Header from "../components/Header";
import Footer from "../components/Footer"

function TestPage() {
  return (
    <div className="test-page">
      <Header />


      <Footer />
    </div>
  );
}


export default TestPage;
